import { render, staticRenderFns } from "./AppOnboardingStepFreeLuts.vue?vue&type=template&id=7c68d3bc&scoped=true&"
import script from "./AppOnboardingStepFreeLuts.vue?vue&type=script&lang=js&"
export * from "./AppOnboardingStepFreeLuts.vue?vue&type=script&lang=js&"
import style0 from "./AppOnboardingStepFreeLuts.vue?vue&type=style&index=0&id=7c68d3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c68d3bc",
  null
  
)

export default component.exports